<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary font-weight-bold text-white d-flex align-items-center">
      {{ this.$string.sidebar.menu_7.sub_menu.menu_2 }}
      <template v-if="role_status && role_status.status_export_excel">
        <CButton color="info" class="btn-md ml-auto mr-2">Ekspor Excel</CButton>
      </template>
      <template v-else> 
        <CButton color="secondary" class="btn-md ml-auto mr-2" disabled>Ekspor Excel</CButton>
      </template>
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md"
        @click="myModal = true"
      >Tambah</CButton>
      </template>
      <template v-else> 
      <CButton
        color="secondary"
        style="float:right;margin-right:10px"
        class="btn-md"
        disabled
      >Tambah</CButton>
      </template>     
    </CCardHeader>
    <!-- Data Broadcast -->
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #subject="{item}">
              <td class="py-2">{{item.subject ? item.subject : "-"}}</td>
            </template>
            <template #pesan="{item}">
              <td class="py-2">
                {{ item.pesan.length > 100 ? item.pesan.substring(0, 100) + '...' : item.pesan }}
              </td>
            </template>
            <template #created_at="{item}">
              <td class="py-2">
                {{ item.created_at | moment }}
              </td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 text-center">
                <template v-if="role_status && role_status.status_read">
                <CButton color="success" class="btn-sm text-white mr-1" square @click="showDetailPesan(item)">
                  <font-awesome-icon icon="eye" />
                </CButton>
                </template>
                <template v-else>
                <CButton color="secondary" class="btn-sm text-white mr-1" square disabled>
                  <font-awesome-icon icon="eye" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />  
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Kirim Pesan"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Pesan</h6>          
        </template>
        <CForm>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for="tujuan" class="font-weight-bold">Tujuan</label>                                
                <div>                  
                  <multiselect 
                    v-model="formData.tujuan" 
                    placeholder="Pilih tujuan" 
                    label="nama_lengkap" 
                    track-by="email" 
                    :options="receiverOptions" 
                    :multiple="true"            
                    @remove="removeSingleReceiver"        
                  >                    
                    <template v-slot:noResult>
                      User tidak ditemukan
                    </template>
                  </multiselect>           
                </div>            
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-check mt-1">
                      <input class="form-check-input" type="checkbox" :value="selectAllReceiver" v-model="selectAllReceiver" id="defaultCheck1">
                      <label class="form-check-label" for="selectAllReceiver">
                        Pilih semua
                      </label>
                    </div>                       
                  </div>
                  <div class="col-md-6" v-if="formData.tujuan.length > 0">
                    <div class="form-check mt-1">
                      <input class="form-check-input" type="checkbox" :value="deleteAllReceiver" v-model="deleteAllReceiver" id="defaultCheck1" @click="deleteAllReceiver = true">
                      <label class="form-check-label" for="selectAllReceiver">
                        Hapus semua
                      </label>
                    </div>
                  </div>
                </div>   
              </div>
            </CCol>            
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" v-model="formData.subject" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                rows="3"
                class="font-weight-bold"
                label="Pesan"
                placeholder="Masukkan Isi Pesan"
                v-model="formData.pesan"
              />
            </CCol>
            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <ul class="list-group mb-2">
                <li 
                  v-for="(file, index) in formData.file"
                  class="list-group-item py-1 d-flex justify-content-between align-items-center"
                  :key="index"
                >
                  {{ file.name.substr(0, 50) + "..." }}
                  <button class="btn btn-sm e-transparent" @click="handleRemoveFile(file, index)">
                    <font-awesome-icon icon="times" class="text-danger" />
                  </button>
                </li>   
              </ul>
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input text-truncate" id="customFile" accept="image/*" multiple @change="handleFileUpload">
                <label class="custom-file-label text-truncate" for="customFile" data-browse="Pilih File">Attachments</label>
              </div>
              <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
            </CCol>
          </CRow>
        </CForm>        
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success" @click="sendAppBroadcast">Kirim</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail -->
      <CModal
        title="Detail Pesan"        
        :show.sync="detailModal"                 
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail Pesan</h6>          
        </template>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tbody>              
              <tr>
                <th>Subjek</th>
                <th v-for="(single, index) in item.data" :key="single.idBroadcastAplikasi" v-if="index === 0">
                  {{ single.subject }}
                </th>
              </tr>
              <th>Subjek</th>
                <th v-for="(single, index) in item.data" :key="single.idBroadcastAplikasi" v-if="index === 0">
                  {{ single.text }}
                </th>                                        
              <tr>
                <th>Jumlah Tujuan</th>
                <th>  
                  {{ item.data ? item.data.length : '0' }}
                  <a                     
                    data-toggle="collapse" 
                    href="#collapseEmailTo" 
                    role="button" 
                    aria-expanded="false" 
                    aria-controls="collapseEmailTo"                    
                  >
                    (Detail)
                  </a>
                </th>                
              </tr>   
              <tr v-if="item.data">
                <th colspan="2" class="collapse" id="collapseEmailTo" v-if="item.data">
                  <h4>
                    <span class="badge badge-secondary mr-2" v-for="(item, index) in item.data" :key="index">
                      {{ item.nama_lengkap.split(' ').slice(0, -1).join(' ') }}
                    </span>
                  </h4>
                </th>
              </tr>            
              <tr>
                <th>Tanggal Pengiriman</th>                
                <th v-for="(single, index) in item.data" :key="single.idBroadcastAplikasi" v-if="index === 0">
                  {{ single.created_at | moment }}
                </th>
              </tr>                 
            </tbody>
          </table>
        </div>
        <template #footer>
          <CButton @click="detailModal = false" color="danger">Tutup</CButton>          
        </template>
      </CModal>
      <!-- Modal Detail -->
    </CCardBody>
    <!-- End Data Broadcast -->
  </CCard>
</template>

<script>
import AppBroadcastService from '../../services/broadcast/app-broadcast.service';
import DataKeanggotaanService from '../../services/keanggotaan/data-anggota.service';
import { AlertUtils } from "../../mixins/AlertUtils";
import moment from 'moment';

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  }, 
  {
    key: "subject",
    label: "Subjek",
    sorter: true,
    filter: false
  },
  {
    key: "text",
    label: "Isi Pesan",
    sorter: true,
    filter: false
  }, 
  {
    key: "created_at",
    label: "Waktu Kirim",
    sorter: true,
    filter: false,
  },  
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Broadcast-Applikasi",
  data() {
    return {
      item: {}, // Single Broadcast Aplikasi
      items: [],   
      formData: {
        tujuan: [],
        subject: '',
        pesan: '',
        file: []
      },      
      selectAllReceiver: false, 
      deleteAllReceiver: false,
      receiverOptions: [],
      fileName: "Choose File...",
      fields,      
      details: [],
      no: 1,
      pagination: {
        totalPages: 0
      },
      search: "",
      pageSize: "10",            
      currentPage: 0,
      status: false,
      myModal: false,
      detailModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      detailModal: false,      
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mixins: [
    AlertUtils
  ],

  filters: {
    moment: function (date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },

  watch: {
    selectAllReceiver: function() {    
      if(this.selectAllReceiver) {
        this.formData.tujuan = this.receiverOptions;   
        this.deleteAllReceiver = false;     
      } else if(this.formData.tujuan.length !== this.receiverOptions) {
        this.selectAllReceiver = false;
        this.deleteAllReceiver = false;
      } else {
        this.formData.tujuan = [];
        this.deleteAllReceiver = false
      }      
    },

    deleteAllReceiver: function() {
      this.formData.tujuan = [];
      if(this.deleteAllReceiver) {
        this.selectAllReceiver = false;
      } else if(this.selectAllReceiver) {      
        this.formData.tujuan = this.receiverOptions;   
        this.deleteAllReceiver = false;   
      } else {
        this.deleteAllReceiver;
      }
    },

    search: function (val) {
       clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {          
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * 10;      
      this.getData(val - 1, this.pageSize, this.search);      
    }
  },

  mounted() {
    this.getData("0", this.pageSize, "default");
    this.getAllUser();
    this.roleData();
  },

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    changePageSize(e) {      
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    pageChange() {
      this.getData(currentPage);
    },

    handleFileUpload(e) {
      let file = e.target.files;
      if(file.length)        
        this.formData.file.push(e.target.files[0]);          
    },

    handleRemoveFile(file, index) {      
      this.formData.file.splice(index, 1);
    },    

    removeSingleReceiver(item) {
      this.selectAllReceiver = false;
    },

    sendAppBroadcast() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });              
      AppBroadcastService.postAppBroadcast(this.formData)
        .then(response => {
          // comment console console.log('success');
          this.clearFormData();
          this.myModal = false;
          this.getData("0", this.pageSize, "default");
          setTimeout(() => loader.hide(), 1000);
        })     
    },

    clearFormData() {
      this.formData = {
        tujuan: [],
        subject: '',
        pesan: '',
        file: []
      }
    },

    showDetailPesan(item) {
      this.detailModal = true;      
      AppBroadcastService.getDetailAppBroadcast(item.idBroadcastAplikasi)
        .then(response => {
          this.item = response.data;
          this.detailModal = true;
        })
    },
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      AppBroadcastService.getAppBroadcast(currentPage, pageSize, filter)
        .then(response => {
          // comment console console.log(response);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getAllUser() {
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          this.receiverOptions = response.data.data;          
        })
        .catch(error => {
          // comment console console.log(error)
        })
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>